import React from 'react';
import Need from '../components/Need';

const Needs = () => <Need />;

export default Needs;
